// extracted by mini-css-extract-plugin
module.exports = {"animated-background":"SingleBarChart_animated-background__3d7ig","placeHolderShimmer":"SingleBarChart_placeHolderShimmer__2xqh6","shimmer":"SingleBarChart_shimmer__3ud2j"};